import { render, staticRenderFns } from "./SectionSettings.vue?vue&type=template&id=c0462b64&scoped=true&"
import script from "./SectionSettings.vue?vue&type=script&lang=js&"
export * from "./SectionSettings.vue?vue&type=script&lang=js&"
import style0 from "./SectionSettings.vue?vue&type=style&index=0&id=c0462b64&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0462b64",
  null
  
)

export default component.exports